export default __webpack_public_path__ + "static/media/Custom-HUD-01.1010a767.jpg";